module.exports = __webpack_public_path__ + "assets/varnish.565ab655.svg";